module.exports = __webpack_public_path__ + "static/media/mail.6a005eb6.png";